import useInputChange from "hooks/useInputChange";
import { FormEvent } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { requestFundsApprovalOtp } from "services/general.service";

interface Props {
  onCancel: () => void;
  onSubmit: (otp: string) => void;
  message: string;
  isLoading: boolean;
}
export default function OtpForm({
  onCancel,
  message,
  isLoading,
  onSubmit,
}: Props) {
  const { state, onChange } = useInputChange<{ otp: string }>({
    otp: "",
  });

  const { isLoading: requsting, mutate: otpMutate } = useMutation(
    async () => await requestFundsApprovalOtp(),
    {
      onSuccess(data) {
        toast.success(data?.message);
      },
      onError(error: any) {
        toast.error(error?.response?.data?.message);
      },
    }
  );

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    onSubmit(state.otp);
  };

  const handleOtp = () => {
    otpMutate();
  };
  return (
    <form action="#!" onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Enter OTP
        </label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="Enter OTP"
          name="otp"
          onChange={onChange}
          value={state.otp}
          required
        />
        <button
          type="button"
          onClick={handleOtp}
          className=" border-none text-blue-500"
        >
          {requsting ? "Sending..." : "Request OTP"}
        </button>
      </div>
      {message && <span className=" text-sm text-red-500">{message}</span>}
      <div className="flex justify-end gap-2 mt-4">
        <button
          type="reset"
          data-modal-close="addDocuments"
          className="px-4 py-2 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors"
        >
          {isLoading ? "Loading..." : "Submit"}
        </button>
      </div>
    </form>
  );
}
